import InventoryList from "./list";

const Inventory = (props) => {
    return (
        <InventoryList/>
    )
}
export default Inventory;